export const UPDATE_FORM = "UPDATE_FORM";
export const SET_REQUEST = "SET_REQUEST";
export const GET_STEP = "GET_STEP";
export const UPDATE_WORKFLOW = "UPDATE_WORKFLOW";